import { useState, useEffect } from 'react';
import './Pagination.style.css';
import {
  DoubleLeftOutlined,
  DoubleRightOutlined,
  LeftOutlined,
  RightOutlined,
} from '@ant-design/icons';
import styled from 'styled-components';

const Button = styled.button`
  &.active {
    ${(props) => props.activeStyle}
  }

  &:hover {
    ${(props) => props.hoverStyle}
  }

  &.pagination_nav_button {
    ${(props) => props.navStyle}
  }
`;

const Pagination = ({
  current = 1,
  pageSize = 10,
  total = 0,
  onChange = () => { },
  showPage = 5,
  prev = <LeftOutlined />,
  next = <RightOutlined />,
  style = {},
  buttonStyle = {},
  activeStyle = {},
  hoverStyle = {},
  navStyle = {},
  position = 'center',
  isButton = false,
  isLatestButton = false,
  first = <DoubleLeftOutlined />,
  last = <DoubleRightOutlined />,
}) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  const [currentPage, setCurrentPage] = useState(current);
  const [pages, setPages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  /* ===== Hooks ===== */
  useEffect(() => {
    const count = Math.ceil(total / pageSize);

    let arr = [];
    const tempArr = [];
    for (let i = 1; i <= count; i++) {
      arr.push(i);

      if (i % showPage === 0 || i === count) {
        tempArr.push(arr);
        arr = [];
      }
    }
    setPages(tempArr);
  }, [total, pageSize, showPage]);

  useEffect(() => {
    let cur = 0;
    pages.some((arr, index) => {
      return arr.some((value, subIndex) => {
        if (value === currentPage) {
          cur = index;
          return true;
        }
        return false;
      });
    });

    setCurrentIndex(cur);
  }, [currentPage, pages]);

  useEffect(() => {
    if (current !== currentPage) {
      handlePagination(current);
    }
  }, [current, currentPage]);

  /* ===== Function ===== */
  const handlePagination = (page) => {
    setCurrentPage(page);
    onChange(page);
  };

  const handleNavigatePage = (t) => {
    const type = t.toLocaleUpperCase();

    switch (type) {
      case 'FIRST':
        handlePagination(1);
        break;
      case 'PREV':
        handlePagination(currentPage - 1);
        break;
      case 'NEXT':
        handlePagination(currentPage + 1);
        break;
      case 'LAST':
        handlePagination(
          pages[pages.length - 1][pages[pages.length - 1].length - 1]
        );
        break;
      default:
        break;
    }
  };

  const PageButton = ({
    label,
    onClick,
    style,
    className,
    disabled,
    ...props
  }) => {
    return (
      <Button
        className={`pagination_button ${className} ${disabled ? 'disabled' : ''
          }`}
        disabled={disabled}
        onClick={onClick}
        {...props}
        style={{ ...style, ...buttonStyle }}
        activeStyle={activeStyle}
        hoverStyle={hoverStyle}
        navStyle={navStyle}
      >
        {label}
      </Button>
    );
  };

  if (!total) return;

  /* ===== Variable ===== */
  /* ===== Hooks ===== */

  /* ===== Render ===== */
  return (
    <div
      className="pagination_layout"
      style={{ justifyContent: position, ...style }}
    >
      {isLatestButton && (
        <div className="pagination_first_button pagination_nav_button">
          <PageButton
            label={first}
            onClick={() => handleNavigatePage('first')}
            disabled={currentIndex === 0 && currentPage === 1}
            style={{ opacity: currentPage === 1 ? 0 : 1 }}
          />
        </div>
      )}

      {isButton && (
        <div className="pagination_prev_button pagination_nav_button">
          <PageButton
            label={prev}
            onClick={() => handleNavigatePage('prev')}
            disabled={currentIndex === 0 && currentPage === 1}
            style={{ opacity: currentPage === 1 ? 0 : 1 }}
          />
        </div>
      )}

      <ul className="pagination_page">
        {pages[currentIndex]?.map((_item) => (
          <li key={`page_${_item}`}>
            <PageButton
              className={_item === currentPage ? 'active' : ''}
              label={_item}
              onClick={() => handlePagination(_item)}
            />
          </li>
        ))}
      </ul>

      {isButton && (
        <div className="pagination_next_button pagination_nav_button">
          <PageButton
            label={next}
            onClick={() => handleNavigatePage('next')}
            disabled={
              currentIndex + 1 === pages.length &&
              currentPage ===
              pages[pages.length - 1][pages[pages.length - 1].length - 1]
              // pages.length
              // ? currentPage === pages[pages.length - 1].length
              // : false
            }
            style={{
              opacity:
                currentIndex + 1 === pages.length &&
                  (currentPage ===
                    pages[pages.length - 1].length
                  )
                  ? 0
                  : 1,
            }}
          />
        </div>
      )}

      {isLatestButton && (
        <div className="pagination_last_button pagination_nav_button">
          <PageButton
            label={last}
            onClick={() => handleNavigatePage('last')}
            disabled={
              pages.length
                ? currentIndex + 1 === pages[pages.length - 1].length
                : false
            }
            style={{
              opacity: currentIndex + 1 === pages.length ? 0 : 1,
            }}
          />
        </div>
      )}
    </div>
  );
};

export default Pagination;
